var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('v-layout',{attrs:{"navMargin":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mt-3":""}},[_c('h1',{staticClass:"my-4 font-weight-black"},[_vm._v("Frequently Asked Questions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pa-2":""}},[_c('FAQPanel',{attrs:{"questions":_vm.questions}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55321013","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/FAQ.vue
// module id = null
// module chunks = 